// Hücre editörü başlığı + sekme şeridi (Değer / Kanıt / Geçmiş) — KpiCellEditor.tsx'ten salt taşıma
// (≤600 satır kuralı; kırılım bölümü editöre eklendiği için ayrıldı).

import { KPI_EVIDENCE_COPY } from "../../lib/kpi-evidence-copy";
import type { CellEditorTab } from "./KpiCellEditor";

export function KpiCellEditorHeader(props: {
  title: string;
  tab: CellEditorTab;
  onTab: (t: CellEditorTab) => void;
  valueTab: boolean;
  evidenceCount: number;
  /** kırılım toplamı yeniden hesaplanıyor — başlıkta `aria-busy` + bekleme metni (DR4) */
  busy?: string | null | undefined;
}): JSX.Element {
  const { title, tab, onTab, valueTab, evidenceCount, busy } = props;
  const tabBtn = (t: CellEditorTab, label: string): JSX.Element => (
    <button
      key={t}
      type="button"
      role="tab"
      aria-selected={tab === t}
      data-testid={`kpi-cell-tab-${t}`}
      onClick={() => onTab(t)}
      className="px-3 py-1 text-xs font-semibold"
      style={{
        borderRadius: 999,
        background:
          tab === t ? "color-mix(in srgb, var(--color-primary) 10%, white)" : "transparent",
        color: tab === t ? "var(--color-primary)" : "var(--color-text-2)",
        minHeight: 30,
      }}
    >
      {label}
    </button>
  );
  return (
    <>
      <div
        className="text-sm font-semibold mb-2"
        style={{ color: "var(--color-text)", opacity: busy ? 0.6 : undefined }}
        aria-busy={busy ? true : undefined}
      >
        {title}
        {busy ? (
          <span
            role="status"
            data-testid="kpi-cell-editor-busy"
            className="ml-2 text-xs font-normal"
            style={{ color: "var(--color-text-3)" }}
          >
            {busy}
          </span>
        ) : null}
      </div>
      <div
        role="tablist"
        aria-label="Hücre sekmeleri"
        className="flex gap-1 mb-3"
        style={{ borderBottom: "1px solid var(--color-border)", paddingBottom: 6 }}
      >
        {valueTab ? tabBtn("value", KPI_EVIDENCE_COPY.tabs.value) : null}
        {tabBtn(
          "evidence",
          evidenceCount > 0
            ? `${KPI_EVIDENCE_COPY.tabs.evidence} (${evidenceCount.toString()})`
            : KPI_EVIDENCE_COPY.tabs.evidence,
        )}
        {tabBtn("history", KPI_EVIDENCE_COPY.tabs.history)}
      </div>
    </>
  );
}
